import React from 'react';
import { Badge as RadixBadge } from '@radix-ui/themes';

const Badge = ({ children, variant = 'info', size = 'medium' }) => {
  const colorMap = {
    success: 'green',
    warning: 'orange',
    danger: 'red',
    info: 'blue',
    primary: 'orange',
  };

  const sizeMap = { small: '1', medium: '2', large: '3' };

  return (
    <RadixBadge color={colorMap[variant] || 'gray'} size={sizeMap[size] || '2'}>
      {children}
    </RadixBadge>
  );
};

export default Badge;
